export const ENV = {
  API_ROOT: "https://api.qikreach.net/api",//"http://localhost:49767/api", , "http://localhost:5000/api"//, //"http://localhost:49767/api", ,,remember https and start up cors for report
};

